import { Box, Flex, Text, Button, HStack } from '@skin-seoul/design-system';
import type { ReviewImage } from '..';

interface ReviewImageGalleryProps {
  images: ReviewImage[];
  onViewAll?: () => void;
}

export const ReviewImageGallery = ({ images, onViewAll }: ReviewImageGalleryProps) => {
  const handleImageClick = () => {
    if (onViewAll) {
      onViewAll();
    }
  };

  const hasImages = images && images.length > 0;

  return (
    <Box w="full">
      <Flex justify="space-between" align="center" mb="14px">
        <Text
          textStyle={{
            base: 'label.medium',
            tablet: 'heading.h6',
          }}
          m="0"
        >
          Images from reviews
        </Text>
        {hasImages && (
          <Button
            bg="none"
            border="none"
            color="neutral.400"
            textStyle="label.small"
            maxH="fit-content"
            p="0"
            fontFamily="General Sans, sans-serif"
            onClick={onViewAll}
          >
            View all
          </Button>
        )}
      </Flex>
      {hasImages ? (
        <HStack
          gap={2}
          maxW="w-full"
          overflowX="auto"
          css={{
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
          }}
        >
          {images.map((image) => (
            <Box
              key={image.id}
              flex="0 0 100px"
              w="100px"
              h="100px"
              borderRadius="8px"
              overflow="hidden"
              cursor="pointer"
              onClick={handleImageClick}
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src={image.url}
                alt={image.alt}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
          ))}
        </HStack>
      ) : (
        <Flex align="center" justify="center" h="100px" bg="#f8f8f8" borderRadius="8px" mt="8px">
          <Text style={{ fontSize: '14px' }} color="#6e6e6e" textAlign="center" m="0">
            No customer images yet
          </Text>
        </Flex>
      )}
    </Box>
  );
};

export default ReviewImageGallery;
